import React, {useState} from 'react'
import {Block, Row} from 'jsxstyle'
import {ReactComponent as GlobeIcon} from '../../../common/assets/globe-icon.svg'
import i18n from '../../../common/i18n'
import Toast from '../../../components/Toast'

interface XpertKnowledgeTutorialPublicBarProps {
  xpertKnowledgeId: string
}

const XpertKnowledgeTutorialPublicBar: React.FC<XpertKnowledgeTutorialPublicBarProps> = ({xpertKnowledgeId}) => {
  const [showToast, setShowToast] = useState(false)

  return (
    <>
      <Toast message={i18n.t('xk.tutorial.copyLinkToast')} showToast={showToast} setShowToast={(show) => setShowToast(show)} />
      <Row flex="none" height="50px" width="100%" alignItems="center" justifyContent="center" gap="12px" backgroundColor="#EDE7F4">
        <GlobeIcon width={16} height={16} color="#4D5560" />
        <Block fontSize="14px" fontWeight={300} color="#4D5560">
          {i18n.t('xk.tutorial.publicBannerLabel')}
        </Block>
        <Block
          textDecoration="underline"
          color="#4D5560"
          cursor="pointer"
          props={{
            onClick: () => window.open(`/xpert-knowledge/${xpertKnowledgeId}/public`),
          }}
        >
          {i18n.t('xk.tutorial.viewPublic')}
        </Block>
        <Block
          textDecoration="underline"
          color="#4D5560"
          cursor="pointer"
          props={{
            onClick: () => {
              navigator.clipboard.writeText(`${window.location.origin}/xpert-knowledge/${xpertKnowledgeId}/public`)
              setShowToast(true)
            },
          }}
        >
          {i18n.t('xk.tutorial.copyLink')}
        </Block>
      </Row>
    </>
  )
}

export default XpertKnowledgeTutorialPublicBar
